// item 1363/1581 — does an uploaded filename look like one of OUR generated documents (so it must
// not be filed as "the client's PO" and mailed back to them)? Our numbers are PREFIX-1xxxxx
// (INV-100813, PO-100814, WO-100687 …) plus legacy NTINV/TWINV/ITINV numbers. The old
// "any prefix + 4 digits" rule refused customers' own PO files like "PO-261020-004.pdf".
// Keep in sync with basix.bl/Email/ClientPoAttachmentRules.cs.
const BASIX_DOC_NUMBER = /\b(?:(?:INV|WO|SO|PROP|PO|CM|COMM|TIME|IC)-?1\d{5}|(?:NTINV|TWINV|ITINV)\d{4,})(?!\d)/i;

const looksLikeBasixDocument = (fileName?: string | null): boolean => !!fileName && BASIX_DOC_NUMBER.test(fileName);

export default looksLikeBasixDocument;
